import React, { useState, useEffect, useRef, useContext } from 'react'
import io from 'socket.io-client'
import '../App.css';
import { registerContext } from '../hooks/contextAPI'
import CircularProgress from '@material-ui/core/CircularProgress';
import useFetch from '../hooks/useFetch';
import TextField from "@material-ui/core/TextField"
import AssignmentIcon from "@material-ui/icons/Assignment"
import PhoneIcon from "@material-ui/icons/Phone"
import { CopyToClipboard } from "react-copy-to-clipboard"
import Peer from "simple-peer"
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import axios from 'axios'
import DotLoader from 'react-spinners/DotLoader'
import { css } from "@emotion/react";
import logo from '../images/Foodies.png'
import Skeleton from '@material-ui/lab/Skeleton';
// https://foodies-startup.herokuapp.com/'
const socket = io.connect('https://foodies-startup.herokuapp.com/') //heroku backend

const map = new Map()
let size;

export const MealBuddyChat = (props) => {

    const [age, location, name, ingr, place] = props.info
    const [msg, setMsg] = useState('')
    const [display, setDisplay] = useState([]) //turn it as object
    const back = useContext(registerContext)
    const [room, setRoom] = useState([age, location])
    const [client, setClients] = useState(0)
    const [joinMsg, setjoinMsg] = useState('')
    const [leaveMsg, setLeave] = useState('')
    const [notice, setNotice] = useState('')
    const [current, setCurrent] = useState('')
    const [names, setNames] = useState([])
    const connectionRef = useRef()
    const [rest, setRes] = useState('')
    const [type, setType] = useState('')
    const [show, setShow] = useState(false)
    const [interest, setInterest] = useState('')
    const [allRooms, setAll] = useState([])
    const [message, setMessage] = useState('')
    const [recipient, setRecipient] = useState('')

    connectionRef.current = socket

    function handleChange(e) {
        setMsg(e.target.value)
    }

    const handleClick = () => {

        if (room !== "" && msg !== "") {
            socket.emit('send-msg', msg, room, recipient)
        }

        let idTag = socket.id + " :  "
        setDisplay([...display, idTag, msg]) //change

        setDisplay([
            ...display,
            {
                username: idTag,
                message: msg
            }
        ]) //changed
    }

    socket.on('receive', (msg, id) => {
        let idTag = id + ": "
        setDisplay([...display, idTag, msg]) //change
        setDisplay([
            ...display,
            {
                username: idTag,
                message: msg
            }
        ]) //changed

    })

    socket.on('send-interest', ingr => {
        setInterest(ingr)
    })

    const joinRoomClick = () => {
        socket.emit('join-room', room, message => {
            setjoinMsg(message)
            alert("You joined a room!")
        })
        socket.emit('send-id', name, room)
        socket.emit('displayRooms', room)

    }

    socket.on('send-notice', notice => {
        setNotice(notice)

    })


    socket.on('current-room', res => {
        if (res !== null || res !== '' || res !== []) {

            setCurrent(res)
        } else {
            setCurrent("No room")
        }

    })

    const renderChat = () => {
        let date = new Date()
        const currentDate = [date.getMonth() + 1, date.getDate(), date.getFullYear()];

        return display.map(({ username, message }, index) => (
            <>
                <div className="chat-bubble" key={index}>
                    <h3>
                        <div className="inner-bubble">
                            {username} <span className="my-chat">{message}</span>
                            <span className="chat-date"> {currentDate.map((dates) => {
                                return <p> {dates + ". "} </p>
                            })} </span>
                        </div>
                    </h3>
                </div>
            </>

        ))
    }

    const leaveRoom = () => {


        socket.emit('leave-room', room, message => {

            if (room !== "") {
                setLeave(message)
                connectionRef.current.disconnect()

                setTimeout(() => {
                    socket.connect()
                }, 1000)
            } else {
                connectionRef.current.disconnect(false)
                setLeave('You have not joined a room yet.')

            }


        })

    }

    useEffect(() => {

        setTimeout(() => {
            if (joinMsg !== "" || leaveMsg !== "" || notice !== "") {
                setjoinMsg('')
                setLeave('')
                setNotice('')
            }
        }, 10000)

        socket.emit('interests', ingr, room)

        socket.on('roomSize', res => {
            size = res.count
            setClients(size)


        })


    }, [notice])

    socket.on('list-users', customID => {
        map.set(1, customID)
        setNames([...names, map.get(1)])
    })


    const renderUser = () => {

        return names.map((id) => {
            <p> ID: </p>
            return (<div>
                <li>
                    {id}
                </li>
            </div>
            )
        })
    }

    const handleBack = () => {
        connectionRef.current.disconnect()// check what it does
        setTimeout(() => {
            socket.connect()
        }, 1000)
        back.setSubmit(!back.submit)
    }

    const handleMealType = (e) => {
        setType(e.target.value)
        setRoom([...room, e.target.value])
        //make alert system
    }

    const handleDish = (e) => {
        setRes(e.target.value)
        setRoom([...room, e.target.value])
    }

    socket.on('displayAll', rooms => {
        setAll([...allRooms, rooms])
    })

    const foodCourse = () => {
        setShow(!show)
        socket.emit('restaurant', type, place)
    }

    const handleChange2 = (e) => {
        setRecipient(e.target.value)
    }

    return (
        <>
            {type === '' && rest === '' && joinMsg === '' && <p> Make sure you have joined a room before browsing food courses. </p>}
            <button className="btns" disabled={type !== '' && rest !== '' ? false : true} onClick={foodCourse}> Show Food Course </button>
            <div className="chat-div">
                <div className="chat--div" >
                    <div className="back-div"> <i class="fas fa-arrow-alt-circle-left fa-2x" onClick={handleBack}></i></div>
                    <p> <strong> Current Room: </strong> <br />{current}</p>
                    <div> <strong> Current Users: </strong> {renderUser()} </div>
                    <br />
                    <strong> Select Your Room: </strong>
                    {/* Food type */}
                    <select onChange={handleMealType} >
                        <option value="" select hidden> --Favourite Cuisine-- </option>
                        <option value="Italian">Italian</option>
                        <option value="Chinese">Chinese</option>
                        <option value="Korean">Korean</option>
                        <option value="British">British</option>
                        <option value="Japanese">Japanese</option>
                        <option value="Mexican">Mexican</option>
                        <option value="Indian"> Indian</option>
                        <option value="North American">North American</option>
                        <option value="South American">South American</option>
                    </select>

                    <select onChange={handleDish}>
                        <option value="" select hidden> --Meal type-- </option>
                        <option value="Main%20course"> Main Course </option>
                        <option value="Starter"> Appetizer </option>
                        <option value="Desserts"> Dessert </option>
                        <option value="snacks"> Snacks </option>
                        <option value="Drinks"> Drinks </option>
                    </select>

                    <h3>All Rooms: </h3>
                    <div className="all-rooms-div">

                        {allRooms.map((r) => {
                            return <div className="all-rooms"> <img src={logo} alt="asd" /> <li> <strong> RoomID: </strong> <br /> {r} </li> </div>
                        })} </div>

                    <input placeholder="message" value={msg} onChange={handleChange} />
                    <input placeholder="ID you wish to DM" value={recipient} onChange={handleChange2} />

                    <button className="btns" onClick={handleClick}> Send Message </button>
                    <button className="btns" onClick={joinRoomClick}> Join </button>
                    <button className="btns" onClick={leaveRoom}> Leave </button>

                    <p> {joinMsg} </p>
                    <p> {leaveMsg} </p>
                    <p> {notice}</p>
                </div>
                <div className="chat-log-div">
                    {client === 1 ? <CircularProgress /> : null}
                    <p>  <strong> Interests:  </strong> {interest} </p>
                    {!show ? renderChat() : <div className="recipe-info"> <Recipes keywords={[type, rest, place]} /> </div>}
                </div>
            </div>
        </>
    )
}


const Recipes = (props) => {

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    `;
    const ID = "9fa7d6d9"
    const API_KEY = "677e0ebe37f89cc112cd93da89bc4874"
    const [type, rest, place] = props.keywords
    const [loading, setLoading] = useState(false)
    const [notice, setNotice] = useState('')
    const [message, setMessage] = useState('')
    const [msg, setMsg] = useState('')
    const [recipient, setRecipient] = useState('')
    const [num, setNum] = useState(0)
    const { state, img, rawData } = useFetch(`https://api.edamam.com/search?q=${type}&app_id=${ID}&app_key=${API_KEY}&from=0&to=100&dishType=${rest}`, num)
    const [resName, setresName] = useState('')
    const [information, setInformation] = useState('')
    const [time, setTime] = useState('')

    const [resInfo, setresInfo] = useState([{
        name: '',
        image: '',
        phone: '',
        rating: '',
        location1: '',
        location2: '',
        location3: ''
    }])


    const [info1, setInfo] = useState([{
        header: '',
        name: '',
        address: '',
        message: '',
        ID: '',
        date: '',
        resname: ''
    }])


    useEffect(() => {
        setNum(Math.floor(Math.random() * 10))
        setTimeout(() => {
            setLoading(true)
        }, 7000);

    }, [])

    useEffect(() => {
        fetch(`/api${place}`)
            .then(res => res.json())
            .then(data => {
                
                    setresInfo([...resInfo, {
                        name:  data.businesses[num].name,
                        image: data.businesses[num].image_url,
                        phone: data.businesses[num].display_phone,
                        rating: data.businesses[num].rating,
                        location1: data.businesses[num].location.display_address[0],
                        location2: data.businesses[num].location.display_address[1],
                        location3: data.businesses[num].location.display_address[2]
                    }])
                
            })
            .catch(e => console.log(e))
    }, [num])

    const handleSend = () => {
        const date = new Date()
        const currentDate = [date.getMonth() + 1, date.getDate(), date.getFullYear()];
        socket.emit('send-info', state, img, message, recipient, currentDate, resName)
        alert("Posted!")
    }

    socket.on('request-date', (title, address, message, id, date, resname) => [
        setInfo([...info1, {
            header: `Post #${info1.length} by ${id} at ${date}`,
            message: message,
            name: title,
            address: address,
            ID: id,
            resname: resname
        }])
    ])

    const handleChange = (e) => {
        setMessage(e.target.value)
        setMsg('*This will send to all when no recipient is declared.')
        setTimeout(() => {
            setMsg('')
        }, 5000)
    }


    return (
        <>
            {/* food */}
            {loading ?
                <>

                    <div className="food-course">
                    <h1> Today's Menu</h1> 
                        <p> {state} </p>
                        <img src={img} alt="" style={{width: '50%'}}/>
                        <button className="btns" onClick={() => setNum(Math.floor(Math.random() * 10))} > Show More </button>
                        <div className="restaurant-container">
                        <h1> Today's Restaurants </h1>
                        {resInfo.map(({ name, image, phone, rating, location1, location2, location3 }, index) => {
                            return (
                                <>
                                    {name !== '' ? <div className="restaurant-lists">
                                        <p> <strong>{name}</strong> </p>
                                        <img src={image} alt="" style={{width: '100%'}}/>
                                        <p> Tel: {phone} </p>
                                        <p> Rating: {rating} </p>
                                        <p> {location1}, {location2}, {location3} </p>
                                        <p> ------------------------------------------ </p>
                                    </div> : null}
                                </>
                            )
                        })}
                        </div>
                    </div>
                    <div className="food-course-2">
                        <h3> Ask Others for a meal date! </h3>
                        <input placeholder="Enter ID you wish to message" onChange={(e) => setRecipient(e.target.value)} />
                        <input placeholder="Additional Message" onChange={handleChange} />
                        <input placeholder="Name of restaurant" onChange={e => setresName(e.target.value)} />
                        <input placeholder="Additional info" onChange={e => setInformation(e.target.value)} />
                        <Scheduler restaurant={[resName, information, state, img]} state={setTime} />
                        <p> {notice} </p>
                        <p style={{ fontSize: '10px', width: '30%', textAlign: 'center' }}> {msg} </p>
                        <button className="btns" onClick={handleSend} > POST </button>
                    </div>


                    <div className="food-course-3">
                        <h3> Posts </h3>
                        {info1.map(({ header, message, name, address, ID,resname }) => {
                            return (
                                <>
                                    {name !== "" && <div className="post">

                                        <p style={{ textDecoration: 'underline' }}> {header} </p>
                                        <p> <strong> Food: </strong> {name} </p>
                                        <p> <strong> Message:</strong> {message} </p>
                                        <img src={address} alt="" className="post-image" />
                                        <p> Restaurant Name: {resname} </p>
                                        <p> Date: {time} </p>
                                        <button onClick={() => { navigator.clipboard.writeText(ID) }} style={{ margin: '5px' }}> Copy ID of Sender </button>
                                    </div>}
                                </>
                            )
                        })}
                        <>
                            <Skeleton variant="text" width={200} height={40} />
                            <Skeleton variant="text" width={200} height={40} />
                            <Skeleton variant="rect" width={200} height={100} />
                        </>
                    </div>

                </> : <div className="loader-div"> <DotLoader color="lightgreen" loading={!loading} css={override} size={150} /> </div>}
        </>
    )
}

//SENDING resInfo to others WORKS -- Todo: Check if it works on multiple sends and work on UIs.

function Scheduler(props) {

    const [selectedDate, setSelectedDate] = React.useState(
        new Date('2014-08-18T21:11:54'),
    );
    const [msg, setMsg] = useState('')
    const [resName, information, menu, menuImg] = props.restaurant
    const { setTime } = props.state


    const handleDateChange = (date) => {
        setSelectedDate(date);
        setTime(date)

    };

    const email = localStorage.getItem('Email')
    const name = localStorage.getItem('Name')

    const handleSubmit = () => {
        let data = {
            name: name,
            email: email,
            resName: resName,
            resAddress: information,
            date: selectedDate,
            menu: menu,
            menuImg: menuImg,
            logo: logo
        }



        axios.post('/email', data)
            .then(res => {
                setMsg('Succesfully Sent!')
            }).catch((err) => {
                setMsg('Failed to send.')
            })
    }


    return (
        <>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Date picker dialog"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
                <KeyboardTimePicker
                    margin="normal"
                    id="time-picker"
                    label="Time picker"
                    onChange={handleDateChange}
                    value={selectedDate}
                    KeyboardButtonProps={{
                        'aria-label': 'change time',
                    }}
                />
            </MuiPickersUtilsProvider>
            <p> {msg} </p>
            <button className="btns" onClick={handleSubmit}> Set Reminder </button>
        </>
    )
}

export default function VideoCall() {

    const [me, setMe] = useState("")
    const [stream, setStream] = useState()
    const [receivingCall, setReceivingCall] = useState(false)
    const [caller, setCaller] = useState("")
    const [callerSignal, setCallerSignal] = useState()
    const [callAccepted, setCallAccepted] = useState(false)
    const [idToCall, setIdToCall] = useState("")
    const [callEnded, setCallEnded] = useState(false)
    const [name, setName] = useState("")
    const myVideo = useRef()
    const userVideo = useRef()
    const connectionRef = useRef()
    const [room, chooseRoom] = useState("")
    const [msg, setMsg] = useState("")

    useEffect(() => {
        navigator.mediaDevices.getUserMedia({ video: true, audio: true })
            .then((stream) => {
                setStream(stream)
                myVideo.current.srcObject = stream
            }).catch(err => console.log(err))

        socket.on("me", (id) => {
            setMe(id)
        })

        socket.on("callUser", (data) => {
            setReceivingCall(true)
            setCaller(data.from)
            setName(data.name)
            setCallerSignal(data.signal)
        })
    }, [])


    const callUser = (id) => {
        const peer = new Peer({
            initiator: true,
            trickle: false,
            stream: stream
        })
        peer.on("signal", (data) => {
            socket.emit("callUser", {
                userToCall: id,
                signalData: data,
                from: me,
                name: name
            })
        })
        peer.on("stream", (stream) => {

            userVideo.current.srcObject = stream

        })
        socket.on("callAccepted", (signal) => {
            setCallAccepted(true)
            peer.signal(signal)
        })

        connectionRef.current = peer
    }

    const answerCall = () => {
        setCallAccepted(true)
        const peer = new Peer({
            initiator: false,
            trickle: false,
            stream: stream
        })
        peer.on("signal", (data) => {
            socket.emit("answerCall", { signal: data, to: caller })
        })
        peer.on("stream", (stream) => {
            userVideo.current.srcObject = stream
        })

        peer.signal(callerSignal)
        connectionRef.current = peer
    }

    const leaveCall = () => {
        setCallEnded(true)
        connectionRef.current.destroy()
    }

    return (
        <>

            <div className="video-chat-container">
                <div className="video-container">
                    <p style={{ textDecoration: "underline", fontWeight: '900', color: 'red' }}> My ID: {me}</p>
                    <div className="video">
                        {stream && <video playsInline ref={myVideo} autoPlay style={{ width: "300px" }} />}
                    </div>
                    <div className="video">
                        {callAccepted && !callEnded ?
                            <video playsInline ref={userVideo} autoPlay style={{ width: "300px" }} /> :
                            null}
                    </div>
                </div>
                <div className="myId">
                    <TextField
                        id="filled-basic"
                        label="Name"
                        variant="filled"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={{ marginBottom: "20px" }}
                    />
                    <p> {msg} </p>
                    <CopyToClipboard text={me} style={{ marginBottom: "2rem" }}>
                        <button className="btns" variant="contained" color="primary" startIcon={<AssignmentIcon fontSize="large" />} onMouseEnter={() => setMsg("You will need to acquire others ID by chat.")} onMouseLeave={() => setMsg("")}>
                            COPY ID
                        </button>
                    </CopyToClipboard>

                    <TextField
                        id="filled-basic"
                        label="ID to call"
                        variant="filled"
                        value={idToCall}
                        onMouseEnter={() => setMsg("You will need to acquire others ID by chat.")}
                        onMouseLeave={() => setMsg("")}
                        onChange={(e) => setIdToCall(e.target.value)}
                    />

                    <TextField
                        id="filled-basic"
                        label="Room"
                        variant="filled"
                        value={room}
                        onChange={(e) => chooseRoom(e.target.value)}
                    />

                    <div className="call-button">
                        {callAccepted && !callEnded ? (
                            <button className="btns" variant="contained" color="secondary" onClick={leaveCall}>
                                End Call
                            </button>
                        ) : (
                            <button className="endcall-btn btns" color="primary" aria-label="call" onClick={() => callUser(idToCall)}>
                                <PhoneIcon fontSize="large" />
                            </button>
                        )}
                        {idToCall}
                    </div>
                </div>
                <div>
                    {receivingCall && !callAccepted ? (
                        <div className="caller">
                            <h1 >{name} is calling...</h1>
                            <button className="btns" variant="contained" color="primary" onClick={answerCall}>
                                Answer
                            </button>
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    )
}


